// extracted by mini-css-extract-plugin
export default {"categoryName":"AllSymptoms_categoryName__VJCO-","listContainer":"AllSymptoms_listContainer__R0oK5","notFound":"AllSymptoms_notFound__YgNQO","button":"AllSymptoms_button__LS6+Z"};